<div class="support-dashboard-container">

  <!-- ═══════════════════════════════════════════════════════════════════════════
       DASHBOARD VIEW
       ═══════════════════════════════════════════════════════════════════════════ -->
  <div [style.display]="viewMode === 'dashboard' ? 'block' : 'none'">

    <!-- 🔹 Date & Dropdown Filters (TOP) -->
    <div class="support-dashboard-filter support-dashboard-filter-row">
      <div class="support-dashboard-filter-controls">
      <div class="support-dashboard-filter-group support-dashboard-organization-filter">
        <label>Accounts</label>
        <ng-select
          class="support-dashboard-organization-select"
          [items]="accountOptions"
          bindLabel="name"
          bindValue="id"
          [clearable]="true"
          [searchable]="true"
          placeholder="All Accounts"
          [ngModel]="selectedAccountDon"
          (change)="onAccountSelectionChange($event)"
        >
          <ng-template ng-option-tmp let-item="item">
            <div class="support-dashboard-assignee-option">
              <span>{{ item.name }}</span>
              <small (click)="drilldownAccount(item, $event)" title="View tickets for {{ item.name }}">{{ item.ticketCount }}</small>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <div class="support-dashboard-filter-group support-dashboard-date-filter">
        <label>Tickets Between</label>
        <div class="date-filter-control">
          <select
            class="support-dashboard-date-preset-select"
            [ngModel]="selectedDatePreset"
            (ngModelChange)="onDatePresetChange($event)"
          >
            <option *ngFor="let opt of datePresetOptions" [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>
          <input
            type="text"
            class="datetimepicker"
            [(ngModel)]="dateRange"
            placeholder="Select date range"
            [style.display]="selectedDatePreset === 'custom' ? 'block' : 'none'"
          />
        </div>
      </div>

      <div class="support-dashboard-filter-group support-dashboard-assignee-filter">
        <label>Assignees</label>
        <ng-select
          class="support-dashboard-assignee-select"
          [items]="assigneeOptions"
          bindLabel="name"
          bindValue="id"
          [multiple]="true"
          [closeOnSelect]="false"
          [hideSelected]="false"
          [clearable]="true"
          [searchable]="true"
          [loading]="loadingAssignees"
          [placeholder]="loadingAssignees ? 'Loading assignees...' : 'All Assignees'"
          [ngModel]="selectedAssignees"
          (change)="onAssigneeSelectionChange($event)"
        >
          <ng-template ng-header-tmp>
            <div
              class="support-dashboard-select-all"
              (click)="selectAllAssignees(); $event.stopPropagation()"
            >
              <input
                type="checkbox"
                [checked]="allAssigneesSelected"
                [indeterminate]="hasAssigneeFilter"
                tabindex="-1"
              />
              <span>Select All</span>
            </div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <div class="support-dashboard-assignee-option">
              <span>{{ item.name }}</span>
              <small (click)="drilldownAssignee(item, $event)" title="View tickets for {{ item.name }}">{{ item.ticketCount }}</small>
            </div>
          </ng-template>

          <ng-template ng-multi-label-tmp let-items="items">
            <div class="support-dashboard-assignee-summary">
              {{ selectedAssigneeSummary }}
            </div>
          </ng-template>
        </ng-select>
      </div>
      </div>

      <div class="support-dashboard-filter-actions">
        <app-support-dashboard-download
          [disabled]="isDownloadDisabled"
          [exportData]="downloadExportData"
          [preparePdfCharts]="prepareDownloadCharts"
          [getChartImageUrl]="getDownloadChartImageUrl"
        ></app-support-dashboard-download>
        <div class="dashboard-view-switch" role="group" aria-label="Dashboard display">
          <button
            type="button"
            [class.active]="dashboardContentView === 'charts'"
            [attr.aria-pressed]="dashboardContentView === 'charts'"
            (click)="setDashboardContentView('charts')"
          >
            <i class="fas fa-chart-pie" aria-hidden="true"></i>
            Charts
          </button>
          <button
            type="button"
            [class.active]="dashboardContentView === 'tables'"
            [attr.aria-pressed]="dashboardContentView === 'tables'"
            (click)="setDashboardContentView('tables')"
          >
            <i class="fas fa-table" aria-hidden="true"></i>
            Table
          </button>
        </div>
      </div>
    </div>

    <!-- 🔹 Main Header 1 -->
    <div class="support-dashboard-card">
      <h2>Support analytics</h2>
    </div>

    <!-- 🔹 Summary Header -->
    <div class="summary-header">
      <div class="summary-item">
        <div class="summary-label">
          {{ slaTrackedTickets !== null ? 'SLA Tracked Tickets' : 'Total Tickets' }}
        </div>
        <div class="summary-value">
          <ng-container *ngIf="loadingTotalTickets || loadingSlaSummaryCards; else totalTicketsValue">
            <img
              src="../assets/img/loading_2.svg"
              alt="loading total tickets"
              class="summary-loader-icon"
            />
          </ng-container>
          <ng-template #totalTicketsValue>
            <a
              href="javascript:void(0)"
              class="support-value-link"
              (click)="openDrilldown({ drilldown: 'kpi', kpi: 'total', title: 'Total Tickets', expectedTotal: dashboardSummaryTotalTickets })"
            >
              {{ dashboardSummaryTotalTickets }}
            </a>
          </ng-template>
        </div>
      </div>

      <div class="summary-item">
        <div class="summary-label">Resolution SLA</div>
        <div class="summary-value" [class.summary-value-loading]="loadingSlaSummaryCards">
          <ng-container *ngIf="loadingSlaSummaryCards; else resolutionSlaValue">
            <img
              src="../assets/img/loading_2.svg"
              alt="loading resolution SLA"
              class="summary-loader-icon"
            />
          </ng-container>
          <ng-template #resolutionSlaValue>
            <a
              href="javascript:void(0)"
              class="support-value-link"
              (click)="openDrilldown({ drilldown: 'kpi', kpi: 'resolution_pct', title: 'Resolution SLA', expectedTotal: dashboardSummaryTotalTickets })"
            >
              {{ resolutionSLA }}
            </a>
          </ng-template>
        </div>
      </div>

      <div class="summary-item">
        <div class="summary-label">Response SLA</div>
        <div class="summary-value" [class.summary-value-loading]="loadingSlaSummaryCards">
          <ng-container *ngIf="loadingSlaSummaryCards; else responseSlaValue">
            <img
              src="../assets/img/loading_2.svg"
              alt="loading response SLA"
              class="summary-loader-icon"
            />
          </ng-container>
          <ng-template #responseSlaValue>
            <a
              href="javascript:void(0)"
              class="support-value-link"
              (click)="openDrilldown({ drilldown: 'kpi', kpi: 'response_pct', title: 'Response SLA', expectedTotal: dashboardSummaryTotalTickets })"
            >
              {{ responseSLA }}
            </a>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="charts-section" [hidden]="dashboardContentView !== 'charts'">
      <div class="section-title">Performance overview</div>
      <div class="charts-grid">
        <div class="chart-panel" [ngClass]="{ loading: volumeByPriorityTableState.loading }">
          <div #volumeByPriorityChart class="support-chart"></div>
          <div class="loading-image-container" *ngIf="volumeByPriorityTableState.loading">
            <img src="../assets/img/loading_2.svg" alt="loading volume by priority chart" />
            <span>Loading chart...</span>
          </div>
        </div>

        <div class="chart-panel" [ngClass]="{ loading: slaComplianceOverallTableState.loading }">
          <div #slaComplianceOverallChart class="support-chart"></div>
          <div class="loading-image-container" *ngIf="slaComplianceOverallTableState.loading">
            <img src="../assets/img/loading_2.svg" alt="loading SLA compliance overall chart" />
            <span>Loading chart...</span>
          </div>
        </div>

        <div class="chart-panel" [ngClass]="{ loading: slaComplianceByPriorityTableState.loading }">
          <div #slaComplianceByPriorityChart class="support-chart"></div>
          <div class="loading-image-container" *ngIf="slaComplianceByPriorityTableState.loading">
            <img src="../assets/img/loading_2.svg" alt="loading SLA compliance by priority chart" />
            <span>Loading chart...</span>
          </div>
        </div>

        <div class="chart-panel" [ngClass]="{ loading: ticketsByCreationTimeTableState.loading }">
          <div #ticketsByCreationTimeChart class="support-chart"></div>
          <div class="loading-image-container" *ngIf="ticketsByCreationTimeTableState.loading">
            <img src="../assets/img/loading_2.svg" alt="loading tickets by creation time chart" />
            <span>Loading chart...</span>
          </div>
        </div>
      </div>
    </div>

    <div [hidden]="dashboardContentView !== 'tables'">
    <div class="support-dashboard-card">
      <h2>Detailed metrics</h2>
    </div>

    <!-- 🔹 1. Volume by Priority -->
    <div class="table-section">
      <div class="section-title">Volume by priority</div>
      <div class="table-content-shell">
        <table>
          <thead>
            <tr>
              <th>Priority</th>
              <th>Count</th>
              <th>Percentage</th>
            </tr>
          </thead>
          <tbody *ngIf="volumeByPriorityTableState.loading">
            <tr>
              <td colspan="3" class="section-loading-cell">
                <img
                  src="../assets/img/loading_2.svg"
                  alt="loading volume by priority"
                  class="support-dashboard-loader-icon"
                />
                Loading volume by priority...
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="!volumeByPriorityTableState.loading && volumeData.length">
            <tr *ngFor="let row of volumeData">
              <td>
                <span class="priority-badge" [ngClass]="row.priority?.toLowerCase()">
                  {{ row.priority }}
                </span>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({ drilldown: 'by_priority', priority: row.priority, title: 'Priority: ' + row.priority, expectedTotal: row.count })"
                >
                  {{ row.count }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({ drilldown: 'by_priority', priority: row.priority, title: 'Priority: ' + row.priority, expectedTotal: row.count })"
                >
                  {{ row.percentage.display }}
                </a>
              </td>
            </tr>

            <tr class="total">
              <td>Total</td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({ drilldown: 'by_priority', priority: 'Total', title: 'Priority: Total', expectedTotal: totalTickets })"
                >
                  {{ totalTickets }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({ drilldown: 'by_priority', priority: 'Total', title: 'Priority: Total', expectedTotal: totalTickets })"
                >
                  100%
                </a>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="!volumeByPriorityTableState.loading && !volumeData.length">
            <tr>
              <td colspan="3" class="section-empty-cell">No Data Found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 🔹 2. SLA Compliance Overall -->
    <div class="table-section">
      <div class="section-title">SLA compliance - overall</div>
      <div class="table-content-shell">
        <table>
          <thead>
            <tr>
              <th>SLA Type</th>
              <th>Met</th>
              <th>Breached</th>
              <th>Total</th>
              <th>Compliance %</th>
            </tr>
          </thead>
          <tbody *ngIf="slaComplianceOverallTableState.loading">
            <tr>
              <td colspan="5" class="section-loading-cell">
                <img
                  src="../assets/img/loading_2.svg"
                  alt="loading SLA compliance overall"
                  class="support-dashboard-loader-icon"
                />
                Loading SLA compliance overall...
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="!slaComplianceOverallTableState.loading && slaOverallData.length">
            <tr *ngFor="let row of slaOverallData">
              <td>{{ row.sla_type }}</td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla',
                    sla: (row.sla_type?.toLowerCase().includes('resolution') ? 'resolution' : 'response'),
                    outcome: 'hit',
                    title: row.sla_type + ' - Met',
                    expectedTotal: row.met
                  })"
                >
                  {{ row.met }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla',
                    sla: (row.sla_type?.toLowerCase().includes('resolution') ? 'resolution' : 'response'),
                    outcome: 'miss',
                    title: row.sla_type + ' - Breached',
                    expectedTotal: row.breached
                  })"
                >
                  {{ row.breached }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla',
                    sla: (row.sla_type?.toLowerCase().includes('resolution') ? 'resolution' : 'response'),
                    outcome: 'all',
                    title: row.sla_type + ' - Total',
                    expectedTotal: row.total
                  })"
                >
                  {{ row.total }}
                </a>
              </td>
              <td class="compliance-cell">
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla',
                    sla: (row.sla_type?.toLowerCase().includes('resolution') ? 'resolution' : 'response'),
                    outcome: 'all',
                    title: row.sla_type + ' - Total',
                    expectedTotal: row.total
                  })"
                >
                  {{ row.compliance_percentage.display }}
                </a>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="!slaComplianceOverallTableState.loading && !slaOverallData.length">
            <tr>
              <td colspan="5" class="section-empty-cell">No Data Found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 🔹 3. SLA Compliance by Priority -->
    <div class="table-section">
      <div class="section-title">SLA compliance by priority</div>
      <div class="table-content-shell">
        <table>
          <thead>
            <tr>
              <th>Priority</th>
              <th>Resolution Met</th>
              <th>Resolution Breached</th>
              <th>Resolution %</th>
              <th>Response Met</th>
              <th>Response Breached</th>
              <th>Response %</th>
            </tr>
          </thead>
          <tbody *ngIf="slaComplianceByPriorityTableState.loading">
            <tr>
              <td colspan="7" class="section-loading-cell">
                <img
                  src="../assets/img/loading_2.svg"
                  alt="loading SLA compliance by priority"
                  class="support-dashboard-loader-icon"
                />
                Loading SLA compliance by priority...
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="!slaComplianceByPriorityTableState.loading && slaPriorityData.length">
            <tr *ngFor="let row of slaPriorityData">
              <td>
                <span class="priority-badge" [ngClass]="row.priority?.toLowerCase()">
                  {{ row.priority }}
                </span>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla_by_priority',
                    priority: row.priority,
                    sla: 'resolution',
                    outcome: 'hit',
                    title: row.priority + ' - Resolution Met',
                    expectedTotal: row.resolution_met
                  })"
                >
                  {{ row.resolution_met }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla_by_priority',
                    priority: row.priority,
                    sla: 'resolution',
                    outcome: 'miss',
                    title: row.priority + ' - Resolution Breached',
                    expectedTotal: row.resolution_breached
                  })"
                >
                  {{ row.resolution_breached }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla_by_priority',
                    priority: row.priority,
                    sla: 'resolution',
                    outcome: 'all',
                    title: row.priority + ' - Resolution Total',
                    expectedTotal: (row.resolution_met + row.resolution_breached)
                  })"
                >
                  {{ row.resolution_percentage.display }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla_by_priority',
                    priority: row.priority,
                    sla: 'response',
                    outcome: 'hit',
                    title: row.priority + ' - Response Met',
                    expectedTotal: row.response_met
                  })"
                >
                  {{ row.response_met }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla_by_priority',
                    priority: row.priority,
                    sla: 'response',
                    outcome: 'miss',
                    title: row.priority + ' - Response Breached',
                    expectedTotal: row.response_breached
                  })"
                >
                  {{ row.response_breached }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla_by_priority',
                    priority: row.priority,
                    sla: 'response',
                    outcome: 'all',
                    title: row.priority + ' - Response Total',
                    expectedTotal: (row.response_met + row.response_breached)
                  })"
                >
                  {{ row.response_percentage.display }}
                </a>
              </td>
            </tr>

            <tr class="total">
              <td>Total</td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla_by_priority',
                    priority: 'Total',
                    sla: 'resolution',
                    outcome: 'hit',
                    title: 'Total - Resolution Met',
                    expectedTotal: slaPriorityTotal.resolution_met
                  })"
                >
                  {{ slaPriorityTotal.resolution_met }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla_by_priority',
                    priority: 'Total',
                    sla: 'resolution',
                    outcome: 'miss',
                    title: 'Total - Resolution Breached',
                    expectedTotal: slaPriorityTotal.resolution_breached
                  })"
                >
                  {{ slaPriorityTotal.resolution_breached }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla_by_priority',
                    priority: 'Total',
                    sla: 'resolution',
                    outcome: 'all',
                    title: 'Total - Resolution Total',
                    expectedTotal: (slaPriorityTotal.resolution_met + slaPriorityTotal.resolution_breached)
                  })"
                >
                  {{ slaPriorityTotal.resolution_percentage.display }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla_by_priority',
                    priority: 'Total',
                    sla: 'response',
                    outcome: 'hit',
                    title: 'Total - Response Met',
                    expectedTotal: slaPriorityTotal.response_met
                  })"
                >
                  {{ slaPriorityTotal.response_met }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla_by_priority',
                    priority: 'Total',
                    sla: 'response',
                    outcome: 'miss',
                    title: 'Total - Response Breached',
                    expectedTotal: slaPriorityTotal.response_breached
                  })"
                >
                  {{ slaPriorityTotal.response_breached }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'sla_by_priority',
                    priority: 'Total',
                    sla: 'response',
                    outcome: 'all',
                    title: 'Total - Response Total',
                    expectedTotal: (slaPriorityTotal.response_met + slaPriorityTotal.response_breached)
                  })"
                >
                  {{ slaPriorityTotal.response_percentage.display }}
                </a>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="!slaComplianceByPriorityTableState.loading && !slaPriorityData.length">
            <tr>
              <td colspan="7" class="section-empty-cell">No Data Found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 🔹 4. Tickets by Creation Time -->
    <div class="table-section">
      <div class="section-title">Tickets by creation time</div>
      <div class="table-content-shell">
        <table>
          <thead>
            <tr>
              <th>Time Period</th>
              <th>Ticket Count</th>
              <th>Percentage</th>
            </tr>
          </thead>
          <tbody *ngIf="ticketsByCreationTimeTableState.loading">
            <tr>
              <td colspan="3" class="section-loading-cell">
                <img
                  src="../assets/img/loading_2.svg"
                  alt="loading tickets by creation time"
                  class="support-dashboard-loader-icon"
                />
                Loading tickets by creation time...
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="!ticketsByCreationTimeTableState.loading && creationTimeData.length">
            <tr *ngFor="let row of creationTimeData; let isLast = last"
                [ngClass]="{'total': isLast}">
              <td>{{ row.time_period }}</td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'by_hour_band',
                    period: row.raw_period,
                    title: 'Creation Time: ' + row.time_period,
                    expectedTotal: row.ticket_count
                  })"
                >
                  {{ row.ticket_count }}
                </a>
              </td>
              <td>
                <a
                  href="javascript:void(0)"
                  class="support-value-link"
                  (click)="openDrilldown({
                    drilldown: 'by_hour_band',
                    period: row.raw_period,
                    title: 'Creation Time: ' + row.time_period,
                    expectedTotal: row.ticket_count
                  })"
                >
                  {{ row.percentage.display }}
                </a>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="!ticketsByCreationTimeTableState.loading && !creationTimeData.length">
            <tr>
              <td colspan="3" class="section-empty-cell">No Data Found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    </div>

  </div><!-- end of dashboard view -->

  <!-- ═══════════════════════════════════════════════════════════════════════════
       DRILLDOWN VIEW
       ═══════════════════════════════════════════════════════════════════════════ -->
  <div class="drilldown-container" *ngIf="viewMode === 'drilldown'">
    <div class="drilldown-header-card">
      <div class="drilldown-header-left">
        <button type="button" class="back-button" (click)="backToDashboard()">
          <i class="fas fa-arrow-left"></i> Back to Dashboard
        </button>
        <div>
          <h3>{{ currentDrilldownConfig?.title || 'Tickets Drilldown' }}</h3>
          <small *ngIf="drilldownTotal > 0">Total: {{ drilldownTotal }} ticket(s)</small>
        </div>
      </div>
      <div class="drilldown-header-right">
      </div>
    </div>

    <!-- Info Bar / Filters Active -->
    <div class="drilldown-info-bar">
      <div>
        <strong>Date Range:</strong> {{ dateRange || (startDate + ' to ' + endDate) }}
        <span *ngIf="selectedAccountDon">&nbsp;|&nbsp;<strong>Account:</strong> {{ selectedAccountSummary }}</span>
        <span *ngIf="hasAssigneeFilter">&nbsp;|&nbsp;<strong>Assignees:</strong> {{ selectedAssigneeSummary }}</span>
      </div>
      <div>
        <label>Per page:&nbsp;</label>
        <select
          [ngModel]="drilldownLimit"
          (ngModelChange)="onLimitChange($event)"
          class="form-control"
          style="display:inline-block; width:auto; height:32px; padding:2px 8px; font-size:12px; border-radius: 6px; border: 1px solid #cbd5e1;"
        >
          <option [ngValue]="25">25</option>
          <option [ngValue]="50">50</option>
          <option [ngValue]="100">100</option>
          <option [ngValue]="200">200</option>
        </select>
      </div>
    </div>

    <div *ngIf="drilldownError" class="alert alert-danger" style="border-radius: 8px;">
      <i class="fas fa-exclamation-triangle"></i> {{ drilldownError }}
    </div>

    <div class="drilldown-table-wrapper">
      <table class="drilldown-table">
        <thead>
          <tr>
            <th class="col-sn">S.N.</th>
            <th class="col-id">Ticket ID</th>
            <th class="col-title">Summary</th>
            <th class="col-severity">Severity</th>
            <th class="col-status">Status</th>
            <th class="col-assignees">Assignees</th>
            <th class="col-reporter">Reporter</th>
            <th class="col-date">Created On</th>
          </tr>
        </thead>
        <tbody *ngIf="loadingDrilldown">
          <tr>
            <td colspan="8" class="section-loading-cell">
              <img
                src="../assets/img/loading_2.svg"
                alt="loading drilldown tickets"
                class="support-dashboard-loader-icon"
              />
              Loading tickets...
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!loadingDrilldown && drilldownTickets.length">
          <tr *ngFor="let ticket of drilldownTickets; let i = index">
            <td class="col-sn">{{ drilldownOffset + i + 1 }}</td>
            <td class="col-id">
              <a
                href="javascript:void(0)"
                class="ticket-key-link"
                (click)="openTicketDetail(ticket)"
              >
                {{ getTicketDisplayId(ticket) }}
              </a>
            </td>
            <td class="col-title">{{ getTicketTitle(ticket) }}</td>
            <td class="col-severity">
              <span
                class="priority-badge"
                [ngClass]="(getTicketPriority(ticket) || '').toLowerCase()"
              >
                {{ getTicketPriority(ticket) }}
              </span>
            </td>
            <td class="col-status">
              <span
                class="status-badge"
                [attr.title]="getTicketStatus(ticket).toLowerCase().includes('closed') && getTicketClosed(ticket) !== '-' ? 'Closed on: ' + getTicketClosed(ticket) : null"
              >{{ getTicketStatus(ticket) }}</span>
            </td>
            <td class="col-assignees">{{ getTicketAssignee(ticket) }}</td>
            <td
              class="col-reporter"
              [attr.title]="getTicketReporterEmail(ticket) || null"
            >{{ getTicketReporter(ticket) }}</td>
            <td class="col-date">{{ getTicketCreated(ticket) }}</td>
          </tr>
        </tbody>
        <tbody *ngIf="!loadingDrilldown && !drilldownTickets.length">
          <tr>
            <td colspan="8" class="section-empty-cell">
              No Tickets Found
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Pagination Controls -->
      <div class="pagination-bar" *ngIf="drilldownTotal > 0 || drilldownTickets.length > 0">
        <div>
          Showing {{ drilldownTickets.length > 0 ? drilldownOffset + 1 : 0 }} to {{ drilldownOffset + drilldownTickets.length }} of {{ drilldownTotal }} entries
        </div>
        <div class="pagination-controls">
          <button
            type="button"
            class="pagination-btn"
            [disabled]="drilldownOffset === 0 || loadingDrilldown"
            (click)="prevPage()"
          >
            &laquo; Previous
          </button>
          <span>Page {{ currentPage }} of {{ totalPages }}</span>
          <button
            type="button"
            class="pagination-btn"
            [disabled]="drilldownTickets.length < drilldownLimit || (drilldownOffset + drilldownTickets.length >= drilldownTotal) || loadingDrilldown"
            (click)="nextPage()"
          >
            Next &raquo;
          </button>
        </div>
      </div>
    </div>
  </div><!-- end of drilldown view -->

  <!-- ═══════════════════════════════════════════════════════════════════════════
       SINGLE TICKET DETAIL & MESSAGES VIEW
       ═══════════════════════════════════════════════════════════════════════════ -->
  <div class="ticket-detail-view" *ngIf="viewMode === 'ticket-detail'">
    <div class="drilldown-header-card">
      <div class="drilldown-header-left">
        <button
          type="button"
          class="back-button"
          (click)="currentDrilldownConfig ? backToDrilldown() : backToDashboard()"
        >
          <i class="fas fa-arrow-left"></i>
          {{ currentDrilldownConfig ? 'Back to Tickets' : 'Back to Dashboard' }}
        </button>
        <div>
          <h3>{{ getTicketDisplayId(activeTicket) }} - {{ getTicketTitle(activeTicket) }}</h3>
        </div>
      </div>
    </div>

    <div class="ticket-detail-panels">
      <div class="ticket-detail-sidebar">
    <!-- Case Details Card -->
    <div class="detail-card">
      <div class="detail-card-header">
        <span>Case Details</span>
        <div *ngIf="loadingTicketDetail">
          <img src="../assets/img/loading_2.svg" alt="loading" style="width: 18px;" />
        </div>
      </div>
      <div class="detail-card-body">
        <div class="detail-grid">
          <div class="detail-field">
            <label>Ticket ID</label>
            <span>{{ getTicketDisplayId(activeTicket) }}</span>
          </div>
          <div class="detail-field">
            <label>Severity / Priority</label>
            <span>
              <span
                class="priority-badge"
                [ngClass]="(getTicketPriority(activeTicket) || '').toLowerCase()"
              >
                {{ getTicketPriority(activeTicket) }}
              </span>
            </span>
          </div>
          <div class="detail-field">
            <label>Status</label>
            <span>
              <span class="status-badge">{{ getTicketStatus(activeTicket) }}</span>
            </span>
          </div>
          <div class="detail-field">
            <label>Assignee</label>
            <span>{{ getTicketAssignee(activeTicket) }}</span>
          </div>
          <div class="detail-field">
            <label>Created Date</label>
            <span>{{ getTicketCreated(activeTicket) }}</span>
          </div>
          <div class="detail-field">
            <label>Ticket Type</label>
            <span>{{ getTicketSubtype(activeTicket) }}</span>
          </div>
          <div class="detail-field">
            <label>Account</label>
            <span>{{ getTicketAccount(activeTicket) }}</span>
          </div>
          <div class="detail-field">
            <label>Reporters</label>
            <span>{{ getTicketReporter(activeTicket) }}</span>
          </div>
          <div class="detail-field">
            <label>Closed On</label>
            <span>{{ getTicketClosed(activeTicket) }}</span>
          </div>
        </div>

        <div class="detail-block">
          <label>Subject / Title</label>
          <div class="detail-block-title">
            {{ getTicketTitle(activeTicket) }}
          </div>
        </div>

        <div
          class="detail-block"
          *ngIf="getTicketDescription(activeTicket) && getTicketDescription(activeTicket) !== '-'"
        >
          <label>Description</label>
          <div class="ticket-description-box">
            {{ getTicketDescription(activeTicket) }}
          </div>
        </div>
      </div>
    </div>

      </div>
      <div class="ticket-detail-communication">
    <!-- Correspondence / Messages Card -->
    <div class="detail-card">
      <div class="detail-card-header">
        <span>Customer correspondence</span>
        <span *ngIf="activeTicketMessages.length > 0" style="font-size: 13px; font-weight: normal; color: #64748b;">
          ({{ activeTicketMessages.length }} message{{ activeTicketMessages.length > 1 ? 's' : '' }})
        </span>
      </div>
      <div class="detail-card-body">
        <div *ngIf="loadingMessages && activeTicketMessages.length === 0" style="text-align: center; padding: 32px;">
          <img src="../assets/img/loading_2.svg" alt="loading messages" class="support-dashboard-loader-icon" />
          <span style="display: block; margin-top: 8px; color: #64748b; font-size: 13px;">Loading correspondence...</span>
        </div>

        <div *ngIf="!loadingMessages && activeTicketMessages.length === 0" class="no-messages">
          No correspondence found for this ticket.
        </div>

        <div *ngIf="activeTicketMessages.length > 0" class="messages-list">
          <div class="message-item" *ngFor="let msg of activeTicketMessages">
            <div class="message-header">
              <div class="message-author-group">
                <div class="message-avatar" [ngClass]="'avatar-' + getAuthorBadge(msg).type">
                  {{ getAuthorInitials(msg) }}
                </div>
                <div class="message-author-info">
                  <div class="message-author-name-row">
                    <span class="message-author">{{ getMessageAuthor(msg) }}</span>
                    <span
                      class="author-badge"
                      [ngClass]="'author-badge-' + getAuthorBadge(msg).type"
                    >
                      {{ getAuthorBadge(msg).label }}
                    </span>
                    <span class="body-type-badge" *ngIf="isEmailPreview(msg)">
                      <i class="fas fa-envelope"></i> Email
                    </span>
                    <span class="body-type-badge" *ngIf="msg.body_type && !isEmailPreview(msg)">
                      {{ msg.body_type }}
                    </span>
                  </div>
                  <span class="message-author-email" *ngIf="getMessageEmail(msg)">
                    {{ getMessageEmail(msg) }}
                  </span>
                </div>
              </div>
              <div class="message-meta">
                <span class="message-visibility" *ngIf="msg.visibility === 'external'">Customer-facing</span>
                <span class="message-date">{{ getMessageDate(msg) }}</span>
              </div>
            </div>

            <!-- Email metadata header when message has email_preview -->
            <div class="email-preview-header" *ngIf="isEmailPreview(msg)">
              <div class="email-meta-row" *ngIf="getEmailSubject(msg)">
                <span class="email-meta-label">Subject:</span>
                <span class="email-meta-value email-subject">{{ getEmailSubject(msg) }}</span>
              </div>
              <div class="email-meta-row" *ngIf="getEmailFrom(msg)">
                <span class="email-meta-label">From:</span>
                <span class="email-meta-value">{{ getEmailFrom(msg) }}</span>
              </div>
              <div class="email-meta-row" *ngIf="getEmailTo(msg)">
                <span class="email-meta-label">To:</span>
                <span class="email-meta-value">{{ getEmailTo(msg) }}</span>
              </div>
            </div>

            <!-- Formatted HTML / Text Body -->
            <div class="message-body" [innerHTML]="getMessageContentHtml(msg)"></div>

            <!-- Attachments / Artifacts -->
            <div class="message-artifacts" *ngIf="getMessageArtifacts(msg).length > 0">
              <div class="artifact-chip" *ngFor="let artifact of getMessageArtifacts(msg)">
                <i class="fas fa-paperclip"></i>
                <span class="artifact-name">{{ artifact.file?.name || artifact.name || artifact.display_id || 'Attachment' }}</span>
                <span class="artifact-size" *ngIf="artifact.file?.size || artifact.size">
                  ({{ formatFileSize(artifact.file?.size || artifact.size) }})
                </span>
              </div>
            </div>
          </div>

          <div style="text-align: center; margin-top: 16px;" *ngIf="messagesNextCursor">
            <button
              type="button"
              class="pagination-btn"
              (click)="loadMoreMessages()"
              [disabled]="loadingMessages"
            >
              {{ loadingMessages ? 'Loading...' : 'Load More Messages' }}
            </button>
          </div>
        </div>
      </div>
    </div>
      </div>
    </div>
  </div><!-- end of ticket-detail view -->

</div>
